import React, { useState, useEffect } from "react";

import { PieChart } from "devextreme-react";
import {
  Border,
  Connector,
  Export,
  Label,
  Legend,
  Series,
} from "devextreme-react/pie-chart";
import axios from "axios";

export default function MdcinClincTestInfoService01PieChart({ sido }) {
  const [dataSource, setDataSource] = useState(null);

  useEffect(() => {
    sido &&
      axios
        .get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/clinicTestOprtnInsttInfoService01/byCLINIC_STEP_NAME`
        )
        .then((result) => {
          setDataSource(
            result.data[sido ? sido : "서울특별시"].CLINIC_STEP_RATIO
          );
        });
  }, [sido]);

  const customizeText = (pointInfo) => {
    return `${Number(pointInfo.value).toLocaleString()} (${
      pointInfo.percentText
    })`;
  };

  return (
    <React.Fragment>
      <PieChart
        id="MdcinClincTestInfoService01PieChart"
        dataSource={dataSource}
        animation={true}
        resolveLabelOverlapping="shift"
        title={sido}
        // style={{ window: "400px", height: "200px" }}
      >
        <Series argumentField="name" valueField="value">
          <Label visible={true} customizeText={customizeText}>
            <Connector visible={true} width={1} />
          </Label>
        </Series>
        <Legend verticalAlignment="bottom">
          <Border color="#e0e0e0" visible={true}></Border>
        </Legend>
        <Export enabled={true} />
      </PieChart>
    </React.Fragment>
  );
}
